// import { FETCH_EXPENSES_SUCCESS, FETCH_EXPENSES_FAIL } from '../constants/expenseConstants';

// export const expenseReducer = (state = { expenses: [] }, action) => {
//   switch (action.type) {
//     case FETCH_EXPENSES_SUCCESS:
//       return { expenses: action.payload };
//     case FETCH_EXPENSES_FAIL:
//       return { error: action.payload };
//     default:
//       return state;
//   }
// };
// redux/reducers/expenseReducers.js
// import {
//     FETCH_EXPENSES_REQUEST,
//     FETCH_EXPENSES_SUCCESS,
//     FETCH_EXPENSES_FAIL,
//     CREATE_EXPENSE_SUCCESS,
//     CREATE_EXPENSE_FAIL,
//     UPDATE_EXPENSE_SUCCESS,
//     UPDATE_EXPENSE_FAIL,
//     DELETE_EXPENSE_SUCCESS,
//     DELETE_EXPENSE_FAIL,
//   } from '../constants/expenseConstants';
  
//   export const expenseListReducer = (state = { expenses: [] }, action) => {
//     switch (action.type) {
//       case FETCH_EXPENSES_REQUEST:
//         return { loading: true, expenses: [] };
//       case FETCH_EXPENSES_SUCCESS:
//         return { loading: false, expenses: action.payload };
//       case FETCH_EXPENSES_FAIL:
//         return { loading: false, error: action.payload };
//       default:
//         return state;
//     }
//   };
  
//   export const expenseDetailsReducer = (state = { expense: {} }, action) => {
//     switch (action.type) {
//       case FETCH_EXPENSES_REQUEST:
//         return { loading: true, ...state };
//       case FETCH_EXPENSES_SUCCESS:
//         return { loading: false, expense: action.payload };
//       case FETCH_EXPENSES_FAIL:
//         return { loading: false, error: action.payload };
//       default:
//         return state;
//     }
//   };
  
//   // Similarly add reducers for create, update, delete actions
import {
    EXPENSE_DETAILS_REQUEST,
    EXPENSE_DETAILS_SUCCESS,
    EXPENSE_DETAILS_FAIL,
    FETCH_EXPENSES_SUCCESS,
    FETCH_EXPENSES_FAIL,
    DELETE_EXPENSE_SUCCESS, 
    DELETE_EXPENSE_FAIL, 
    UPDATE_EXPENSE_SUCCESS, 
    UPDATE_EXPENSE_FAIL 
} from '../constants/expenseConstants';

export const expenseDetailsReducer = (state = { expense: {} }, action) => {
    switch (action.type) {
        case EXPENSE_DETAILS_REQUEST:
            return { loading: true, ...state };
        case EXPENSE_DETAILS_SUCCESS:
            return { loading: false, expense: action.payload };
        case EXPENSE_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const expenseListReducer = (state = { expenses: [] }, action) => {
    switch (action.type) {
        case DELETE_EXPENSE_SUCCESS:
        return {
            ...state,
            expenses: state.expenses.filter(expense => expense._id !== action.payload),
        };
        case DELETE_EXPENSE_FAIL:
        return { ...state, error: action.payload };
        case UPDATE_EXPENSE_SUCCESS:
        return {
            ...state,
            expenses: state.expenses.map(expense =>
            expense._id === action.payload._id ? action.payload : expense
            ),
        };
        case UPDATE_EXPENSE_FAIL:
        return { ...state, error: action.payload };
        case FETCH_EXPENSES_SUCCESS:
            return { loading: false, expenses: action.payload };
        case FETCH_EXPENSES_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};
  